"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
const falconone_1 = require("../../private/api-services/falconone");
const authData_1 = require("../../private/ephemeral/authData");
class User {
    constructor() {
        if (!(authData_1.Auth.getUserToken())) {
            throw new Error("Cannot use User service without authenticated user " +
                "this service is for managing, updating user settings, " +
                "please use the Authenticator service first");
        }
        this.api = new falconone_1.FalconOne(authData_1.Auth.getUserToken());
    }
    /**
     * @description Verify subscription
     *
     * @returns {any}
     * @memberof User
     */
    checkSubscription() {
        return this.api.get("user/subscription-check");
    }
    /**
     * @description Verify iOS subscription receipt
     *
     * @returns {any}
     * @memberof User
     */
    subscribeIOS(receipt) {
        return this.api.post("user/verifyAppleSubscription", { receipt });
    }
    /**
     * @description Verify Android subscription receipt
     *
     * @returns {any}
     * @memberof User
     */
    subscribeAndroid(receipt) {
        return this.api.post("user/verifyGoogleSubscription", { receipt });
    }
    /**
     * @description purchase Android subscription
     *
     * @returns {iResponseSubscribe}
     * @memberof User
     */
    purchaseAndroidSubscription(receipt) {
        return this.api.post("user/purchaseAndroidSubscription", { receipt });
    }
    /**
     * @description purchase iOS subscription
     *
     * @returns {iResponseSubscribe}
     * @memberof User
     */
    purchaseIOSSubscription(receipt) {
        return this.api.post("user/purchaseIOSSubscription", { receipt });
    }
    /**
     * @description Get user (pre?) subscription status
     *
     * @returns {Promise<iSubscriptionStatus>}
     * @memberof User
     */
    getSubscriptionStatus() {
        return this.api.get("user/subscriptionStatus");
    }
    /**
     * @description Get user subscription history
     *
     * @returns {Promise<iSubscription>}
     * @memberof User
     */
    getSubscriptionHistory() {
        return this.api.get("user/subscriptionHistory");
    }
    /**
     * @description Change user password
     *
     * @returns {Promise<{status: string}>}
     * @memberof User
     */
    changePassword(newPassword) {
        return this.api.post("user/changepassword", { newPassword });
    }
}
exports.User = User;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9wdWJsaWMvc2VydmljZXMvdXNlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxvRUFBaUU7QUFDakUsK0RBQXdEO0FBR3hELE1BQWEsSUFBSTtJQUdmO1FBQ0UsSUFBSSxDQUFDLENBQUMsZUFBSSxDQUFDLFlBQVksRUFBRSxDQUFDLEVBQUU7WUFDMUIsTUFBTSxJQUFJLEtBQUssQ0FDYixxREFBcUQ7Z0JBQ25ELHdEQUF3RDtnQkFDMUQsNENBQTRDLENBQzdDLENBQUM7U0FDSDtRQUVELElBQUksQ0FBQyxHQUFHLEdBQUcsSUFBSSxxQkFBUyxDQUFNLGVBQUksQ0FBQyxZQUFZLEVBQUUsQ0FBQyxDQUFDO0lBQ3JELENBQUM7SUFFRDs7Ozs7T0FLRztJQUNLLGlCQUFpQjtRQUN2QixPQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsR0FBRyxDQUFNLHlCQUF5QixDQUFDLENBQUM7SUFDdEQsQ0FBQztJQUVEOzs7OztPQUtHO0lBQ0YsWUFBWSxDQUFDLE9BQU87UUFDbkIsT0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBQyw4QkFBOEIsRUFBRSxFQUFFLE9BQU8sRUFBRSxDQUFDLENBQUM7SUFDcEUsQ0FBQztJQUVEOzs7OztPQUtHO0lBQ0ksZ0JBQWdCLENBQUUsT0FBWTtRQUNuQyxPQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFNLCtCQUErQixFQUFFLEVBQUUsT0FBTyxFQUFFLENBQUMsQ0FBQztJQUMxRSxDQUFDO0lBRUQ7Ozs7O09BS0c7SUFDSSwyQkFBMkIsQ0FBRSxPQUFZO1FBQzlDLE9BQU8sSUFBSSxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQXFCLGtDQUFrQyxFQUFFLEVBQUUsT0FBTyxFQUFFLENBQUMsQ0FBQztJQUM1RixDQUFDO0lBRUQ7Ozs7O09BS0c7SUFDSSx1QkFBdUIsQ0FBQyxPQUFPO1FBQ3BDLE9BQU8sSUFBSSxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQXFCLDhCQUE4QixFQUFFLEVBQUUsT0FBTyxFQUFFLENBQUMsQ0FBQztJQUN4RixDQUFDO0lBRUQ7Ozs7O09BS0c7SUFDSSxxQkFBcUI7UUFDMUIsT0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLEdBQUcsQ0FBc0IseUJBQXlCLENBQUUsQ0FBQztJQUN2RSxDQUFDO0lBRUQ7Ozs7O09BS0c7SUFDSyxzQkFBc0I7UUFDNUIsT0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLEdBQUcsQ0FBa0IsMEJBQTBCLENBQUUsQ0FBQztJQUNwRSxDQUFDO0lBRUQ7Ozs7O09BS0c7SUFDSSxjQUFjLENBQUMsV0FBbUI7UUFDdkMsT0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBQyxxQkFBcUIsRUFBRSxFQUFFLFdBQVcsRUFBRSxDQUFFLENBQUM7SUFDaEUsQ0FBQztDQUVGO0FBL0ZELG9CQStGQyJ9